module.exports = __webpack_public_path__ + "static/media/question_icon.6f6d3ec4.svg";